import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  useBreakpointValue,
  Center,
  CircularProgress,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { GiHamburgerMenu } from "react-icons/gi";
import { Header } from "../../components/Header";
import { Sidebar } from "../../components/Sidebar";
import { Pagination } from "../../components/Pagination";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../../services/api";
import { useAuth } from "../../hooks/auth";
import { maskCPF } from "../../utils/mask";
import {format} from 'date-fns'

import { MdSearch, MdClose } from "react-icons/md";
import InputMask from "react-input-mask";

import { UserModal } from "../../components/UserModal";

export interface UserProps {
  _id: string;
  cpfCnpj: string;
  name: string;
  mobile: string;
  createdAt: Date;
  document: string;
  documentImage: string;
  payments: {
    _id: string;
    expiresIn: Date;
    createdAt: Date;
    plan: {
      _id: string;
      name: string;
      description: string;
    };
  }[];
}

export default function Users() {
  const currentTime = new Date()
  const { user } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const [fetching, setIsFetching] = useState(false);
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true,
  });

  const isMdVersion = useBreakpointValue({
    base: false,
    md: true,
  });

  const [users, setUsers] = useState<UserProps[]>([]);
  const [loading, setLoading] = useState(true);

  const [selectedUser, setSelectedUser] = useState<UserProps>({} as UserProps);

  const [cpf, setCpf] = useState("");

  useEffect(() => {
    loadUsers();
  }, []);

  async function loadUsers(cpfData?: string) {
    try {
      setIsFetching(true);
      const { data } = await api.get<UserProps[]>("/users", {
        params: {
          cpf: cpfData ? cpfData : "",
        },
      });

      const formatted = data.map((i) => ({
        ...i,
        cpfCnpj: maskCPF(i.cpfCnpj),
      }));

      setUsers(formatted);
    } catch (error) {
    } finally {
      setLoading(false);
      setIsFetching(false);
    }
  }

  const handleOpenModal = (content: UserProps) => {
    setOpenModal(true);
    setSelectedUser(content);
  };

  const verifyPayment = (content: UserProps) => {
    if(content.payments.length > 0) {

      if(content.payments[0].expiresIn !== null){
        if(currentTime.getTime() < new Date(content.payments[0].expiresIn).getTime()) {
          return {
            text: 'Ativo',
            color: 'green.500'
          }
        }
      }
      
        
    }

    return {
      text: 'Inativo',
      color: 'red.500'
    }
  }

  const lastPayment = (content: UserProps) => {
    if(content.payments.length > 0) {
      if(content.payments[0].createdAt){
        return format(new Date(content.payments[0].createdAt), 'dd/MM/yyyy')
      }
    }
    return ""
  }

  const currentPlan = (content: UserProps) => {
    if(content.payments.length > 0) {
      if(content.payments[0].plan){
        return content.payments[0].plan.name
      }
    }
    return ""
  }

  if (loading) {
    return (
      <Flex direction="column" h="100vh" bg="bg">
        <Header />

        <Flex w="100%" maxWidth={1460} px={isMdVersion ? "10" : "3"}>
          <Sidebar />

          <Box overflowX="auto" flex="1" borderRadius={8} bg="gray" p="6">
            <Flex mb="8" justify="space-between" align="center">
              <Heading fontSize="21" fontWeight="400" color="text">
                Usuários
              </Heading>
            </Flex>
            <Center>
              <CircularProgress
                thickness="4px"
                color="green_primary"
                isIndeterminate
              />
            </Center>
          </Box>
        </Flex>
      </Flex>
    );
  }

  return (
    <>
      {openModal && (
        <UserModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          user={selectedUser}
          setUser={setSelectedUser}
        />
      )}

      <Flex direction="column" h="100vh" bg="bg">
        <Header />

        <Flex w="100%" maxWidth={1460} px={isMdVersion ? "10" : "3"}>
          <Sidebar />

          <Box overflowX="auto" flex="1" borderRadius={8} bg="gray" p="6">
            {/* {isWideVersion && ( */}
            <Flex mb="8" justify="space-between" align="center">
              <Heading fontSize="21" fontWeight="400" color="text">
                Usuários
                {fetching && (
                  <CircularProgress
                    size="20px"
                    marginLeft={3}
                    color="green_primary"
                    isIndeterminate
                  />
                )}
              </Heading>

              <InputGroup size="md" width="300px">
                <Input
                  bg="gray.900"
                  value={cpf}
                  pr="4.5rem"
                  placeholder="busque por nome ou cpf..."
                  as={InputMask}
                  mask={!isNaN(parseInt(cpf)) ? "***.***.***-**" : ""}
                  //@ts-ignore
                  maskChar={null}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      loadUsers(cpf);
                    }
                  }}
                  onChange={(e) => setCpf(e.target.value)}
                />

                <InputRightElement width="4.5rem">
                  <Button h="1.75rem" size="sm" onClick={() => loadUsers(cpf)}>
                    <MdSearch />
                  </Button>
                  {cpf && (
                    <Button
                      h="1.75rem"
                      colorScheme="red"
                      size="sm"
                      onClick={() => {
                        loadUsers("");
                        setCpf("");
                      }}
                    >
                      <MdClose />
                    </Button>
                  )}
                </InputRightElement>
              </InputGroup>
            </Flex>
            {/* )} */}

            <Table colorScheme="whiteAlpha">
              <Thead>
                <Tr color="gray_light">
                  <Th fontWeight="600" fontSize="13" px="1" py="3">
                    Nome
                  </Th>
                  <Th fontWeight="600" fontSize="13" px="1" py="3">
                    CPF
                  </Th>
                  {/* {isMdVersion && (
                  <Th fontWeight="600" fontSize="13" px="1" py="3">
                    Localização
                  </Th>
                )} */}
                {isWideVersion && (
                    <Th fontWeight="600" fontSize="13" px="1" py="3">
                      Cadastro em
                    </Th>
                  )}
                  {isWideVersion && (
                    <Th fontWeight="600" fontSize="13" px="1" py="3">
                      Status
                    </Th>
                  )}
                  {isWideVersion && (
                    <Th fontWeight="600" fontSize="13" px="1" py="3">
                      Plano
                    </Th>
                  )}
                  {isWideVersion && (
                    <Th fontWeight="600" fontSize="13" px="1" py="3">
                      Último pagamento
                    </Th>
                  )}
                  <Th width="8" px="1" py="3"></Th>
                </Tr>
              </Thead>
              <Tbody>
                {users.map((i) => (
                  <Tr key={i._id}>
                    <Td px="1" py="2">
                      <Box>
                        <Box>
                          <Text color="text">{i.name}</Text>
                        </Box>
                      </Box>
                    </Td>
                    <Td color="white" px="1" py="3">
                      {i.cpfCnpj}
                    </Td>
                    {isMdVersion && (
                    <Td color="white" px="1" py="3">
                      {format(new Date(i.createdAt), 'dd/MM/yyyy') }
                    </Td>
                  )}
                    {isWideVersion && (
                      <Td px="1" py="3">
                        <Text color={verifyPayment(i).color}>
                          {verifyPayment(i).text}
                        </Text>
                      </Td>
                    )}
                    {isWideVersion && (
                      <Td px="1" py="3">
                        <Text color="text">
                          {currentPlan(i)}

                        </Text>
                      </Td>
                    )}
                    {isWideVersion && (
                      <Td px="1" py="3">
                        <Text color="text">
                          {lastPayment(i)}

                        </Text>
                      </Td>
                    )}
                    <Td px="1" py="3">
                      <Menu>
                        <MenuButton
                          as={IconButton}
                          aria-label="Options"
                          icon={<GiHamburgerMenu />}
                          variant="outline"
                        />
                        <MenuList>
                          <MenuItem onClick={() => handleOpenModal(i)}>
                            Visualizar usuário
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            <Pagination total={0} totalPerPage={10} onChange={() => {}} />
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
